module.exports = __webpack_public_path__ + "dimer/static/img/projectBG1.5a1589a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projectBG1.jpg
// module id = O4Xu
// module chunks = 0